import { Box, Typography } from '@mui/material'
import styles from './index.module.scss'

export default function PageLayout({
	children,
	pageName = '',
	pageRightHeader = null,
}) {
	return (
		<div className={styles.pageWrap}>
			<div className={styles.pageHeader}>
				<Typography component="h1">{pageName}</Typography>
				<div className={styles.right}>{pageRightHeader}</div>
			</div>

			<Box className={styles.tableWrap}>{children}</Box>
		</div>
	)
}
